
import cfImage from '@/utils/cfImage'

const IMG_BASE = 'https://blog.farescraper.com/wp-content/uploads/2023/11'

export default {
  data () {
    return {
      openFaq: null,
      aiSimCards: [
        { key: 'match', icon: '🏨' },
        { key: 'rate', icon: '💳' },
        { key: 'compared', icon: '🔍' }
      ],
      stats: [
        { key: 'platforms' },
        { key: 'countries' },
        { key: 'fees' },
        { key: 'always' }
      ],
      securityBadges: [
        { key: 'ssl', icon: '🔒' },
        { key: 'noRegistration', icon: '👤' },
        { key: 'payDirect', icon: '💳' },
        { key: 'noFees', icon: '✅' },
        { key: 'worldwide', icon: '🌐' }
      ],
      stepCards: [
        { key: 'one', num: '01' },
        { key: 'two', num: '02' },
        { key: 'three', num: '03' }
      ],
      whyCards: [
        { key: 'compare', icon: '🔍' },
        { key: 'fees', icon: '💸' },
        { key: 'platforms', icon: '🌐' },
        { key: 'phone', icon: '📞' }
      ],
      faqItems: [
        { key: 'free' },
        { key: 'sites' },
        { key: 'account' },
        { key: 'ai' },
        { key: 'why' }
      ],
      destinations: [
        { destinationId: 37687, destination: 'Paris, France', destinationCityname: 'Paris', destinationCountrycode: 'FR', destinationCountryname: 'France', destinationLat: 48.85886575, destinationLon: 2.3469411, destinationType: 'city', countryKey: 'france', img: `${IMG_BASE}/paris.jpg` },
        { destinationId: 1929, destination: 'Dubai, United Arab Emirates', destinationCityname: 'Dubai', destinationCountrycode: 'AE', destinationCountryname: 'United Arab Emirates', destinationLat: 25.19649297861462, destinationLon: 55.27565177734368, destinationType: 'city', countryKey: 'uae', img: `${IMG_BASE}/dubai.jpg` },
        { destinationId: 59560, destination: 'New York, United States', destinationCityname: 'New York', destinationCountrycode: 'US', destinationCountryname: 'United States', destinationLat: 40.75693875868037, destinationLon: -73.98778466540523, destinationType: 'city', countryKey: 'united_states', img: `${IMG_BASE}/new-york.jpg` },
        { destinationId: 42002, destination: 'Barcelona, Catalonia, Spain', destinationCityname: 'Barcelona', destinationCountrycode: 'ES', destinationCountryname: 'Spain', destinationLat: 41.38363830361909, destinationLon: 2.1775294287109546, destinationType: 'city', countryKey: 'spain', img: `${IMG_BASE}/barcelona.jpg` },
        { destinationId: 29230, destination: 'London, England, United Kingdom', destinationCityname: 'London', destinationCountrycode: 'GB', destinationCountryname: 'United Kingdom', destinationLat: 51.49916450106749, destinationLon: -0.12525865742190945, destinationType: 'city', countryKey: 'united_kingdom', img: `${IMG_BASE}/london.jpg` },
        { destinationId: 18056, destination: 'Bangkok, Thailand', destinationCityname: 'Bangkok', destinationCountrycode: 'TH', destinationCountryname: 'Thailand', destinationLat: 13.758842527104928, destinationLon: 100.53239582172853, destinationType: 'city', countryKey: 'thailand', img: `${IMG_BASE}/bangkok.jpg` },
        { destinationId: 42802, destination: 'Rome, Italy', destinationCityname: 'Rome', destinationCountrycode: 'IT', destinationCountryname: 'Italy', destinationLat: 41.90770958319665, destinationLon: 12.493992200927778, destinationType: 'city', countryKey: 'italy', img: `${IMG_BASE}/rome.jpg` },
        { destinationId: 31835, destination: 'Amsterdam, Netherlands', destinationCityname: 'Amsterdam', destinationCountrycode: 'NL', destinationCountryname: 'Netherlands', destinationLat: 52.373401195557584, destinationLon: 4.895869809570286, destinationType: 'city', countryKey: 'netherlands', img: `${IMG_BASE}/amsterdam.jpg` },
        { destinationId: 22200, destination: 'Tokyo, Japan', destinationCityname: 'Tokyo', destinationCountrycode: 'JP', destinationCountryname: 'Japan', destinationLat: 35.68150959595873, destinationLon: 139.76895595758606, destinationType: 'city', countryKey: 'japan', img: `${IMG_BASE}/tokyo.jpg` },
        { destinationId: 53912, destination: 'Miami, Florida, United States', destinationCityname: 'Miami', destinationCountrycode: 'US', destinationCountryname: 'United States', destinationLat: 25.77245363002341, destinationLon: -80.19288752380379, destinationType: 'city', countryKey: 'united_states', img: `${IMG_BASE}/miami.jpg` },
        { destinationId: 18508, destination: 'Bali, Indonesia', destinationCityname: 'Bali', destinationCountrycode: 'ID', destinationCountryname: 'Indonesia', destinationLat: -8.256512435137234, destinationLon: 115.12254995667267, destinationType: 'island', countryKey: 'indonesia', img: 'https://blog.flightgorilla.com/wp-content/uploads/2023/11/bali.jpg' },
        { destinationId: 22748, destination: 'Singapore, Singapore', destinationCityname: 'Singapore', destinationCountrycode: 'SG', destinationCountryname: 'Singapore', destinationLat: 1.3044176557582121, destinationLon: 103.8464029009813, destinationType: 'city', countryKey: 'singapore', img: `${IMG_BASE}/singapore.jpg` }
      ]
    }
  },
  methods: {
    cfImage,
    toggleFaq (key) {
      this.openFaq = this.openFaq === key ? null : key
    },
    buildDestinationHref (dest) {
      const params = new URLSearchParams({
        destination: dest.destination,
        destinationId: dest.destinationId,
        destinationLat: dest.destinationLat,
        destinationLon: dest.destinationLon,
        destinationType: dest.destinationType,
        destinationCityname: dest.destinationCityname,
        destinationCountrycode: dest.destinationCountrycode,
        destinationCountryname: dest.destinationCountryname
      })
      return `/?${params.toString()}`
    },
    prefillSearch (dest) {
      this.$store.commit('setHotelsSearchFormPrefill', dest)
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
}
